import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-55429b27"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "configContainer"
};
const _hoisted_2 = {
  class: "leftSlide"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "left-view"
}, null, -1));
const _hoisted_5 = {
  class: "mapwrap"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_headertop = _resolveComponent("headertop");
  const _component_slidedata = _resolveComponent("slidedata");
  const _component_mapv2assembly = _resolveComponent("mapv2assembly");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_headertop), _createElementVNode("div", _hoisted_2, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.leftSlideArr, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      class: _normalizeClass({
        'active': index === $data.leftIndex
      }),
      key: index,
      onClick: $event => $options.switchSlide(index)
    }, [_hoisted_4, _createElementVNode("h5", null, _toDisplayString(item.name), 1)], 10, _hoisted_3);
  }), 128))])]), _createVNode(_component_slidedata, {
    id: $data.leftIndex
  }, null, 8, ["id"]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_mapv2assembly)])]);
}